import { z } from "zod";

/**
 * The pharmacy itself, as its owners see it on Pharmacy account: its name,
 * contact, where it is, and its plan. Owners only.
 */
export const pharmacyResponse = z.object({
  id: z.string().uuid(),
  /** On every receipt, from every branch. */
  name: z.string(),
  /** The number the pharmacy signed up with. */
  phone: z.string().nullable(),
  currency: z.string(),
  timezone: z.string(),
  plan: z.enum(["basic", "pro"]),
  /** Staff accounts in use, and how many the plan allows (null: no limit). */
  staffCount: z.number().int(),
  staffLimit: z.number().int().nullable(),
  branchCount: z.number().int(),
  /** When it joined. */
  createdAt: z.string(),
});

/** A new name. It is on the next receipt every branch prints. */
export const updatePharmacyRequest = z.object({
  name: z.string().trim().min(2, "Enter the pharmacy's name").max(120),
});

/**
 * Delete the pharmacy: an owner, with their password. Every phone of it is
 * signed out, and its data is erased thirty days later — until then support
 * can bring it back. Google Play requires the way to do it.
 */
export const deletePharmacyRequest = z.object({
  password: z.string().min(1, "Enter your password"),
});

export const deletePharmacyResponse = z.object({
  /** The day its data is erased; until then it can be brought back. */
  erasedAfter: z.string(),
});

/** Days between deleting a pharmacy and erasing it. Fixed in the database too (008_erase_pharmacy.sql). */
export const PHARMACY_ERASE_DAYS = 30;

export type PharmacyResponse = z.infer<typeof pharmacyResponse>;
export type UpdatePharmacyRequest = z.infer<typeof updatePharmacyRequest>;
export type DeletePharmacyRequest = z.infer<typeof deletePharmacyRequest>;
export type DeletePharmacyResponse = z.infer<typeof deletePharmacyResponse>;
